import React from "react";
import { Radio, Palette, Zap, Monitor, Youtube, Award } from "lucide-react";

const FEATURES = [
  { icon: Radio, title: "Live scorebug", desc: "Real-time bottom bar with strikers, bowler, over-by-over sequence and configurable info zones." },
  { icon: Palette, title: "6 broadcast themes", desc: "Sky Live, ESPN, IPL Neon, Broadcast Pro, Minimalist and Classic — one-click swap on air." },
  { icon: Zap, title: "Sub-200ms sync", desc: "Firebase realtime keeps overlay and controller perfectly in sync across devices." },
  { icon: Monitor, title: "vMix + OBS ready", desc: "One overlay URL, drop into Browser Source at 1920×1080. Transparent, no chroma-key." },
  { icon: Youtube, title: "YouTube-live friendly", desc: "Stream to any RTMP destination. Works with YouTube Studio, Facebook Live, Twitch." },
  { icon: Award, title: "Batting & Match summaries", desc: "Push full-card graphics at fall of wicket, innings break, or match end — one click." },
];

export default function FeaturesGrid() {
  return (
    <section id="features" className="py-20 bg-slate-900/40 border-y border-slate-800">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">Everything you need on air</h2>
          <p className="text-slate-400 mt-3">Six broadcast themes. Instant realtime updates. Zero technical setup.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {FEATURES.map((f) => (
            <div key={f.title} className="p-6 rounded-xl bg-slate-800/50 border border-slate-700 hover:border-slate-500 transition">
              <div className="w-12 h-12 rounded-lg bg-blue-600/15 border border-blue-800 flex items-center justify-center text-blue-400 mb-4">
                <f.icon size={22} />
              </div>
              <div className="font-heading text-xl font-extrabold uppercase text-white">{f.title}</div>
              <div className="text-slate-400 text-sm mt-2 leading-relaxed">{f.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
